<template>
  <b-row>
    <b-col>
      <b-card>
        <div slot="header">
          <i class="icon-lock mr-3"/><span>{{ $t('user.password_change_title') }}</span>
          <i v-if="!seePasswords" class="fa fa-eye fa-primary pull-right" @click="seePasswords = true"/>
          <i v-else class="fa fa-eye-slash fa-danger pull-right" @click="seePasswords = false"/>
        </div>
        <b-form-row>
          <b-col cols="12" v-if="oldPassword">
            <b-form-group :label="$t('passwords.old_password')" :invalid-feedback="fErr('old_password')">
              <b-form-input :type="seePasswords ? 'text' : 'password'"
                :placeholder="$t('passwords.old_password_placeholder')"
                :class="{ 'is-invalid' : fErr('old_password') }" v-model="entity.old_password"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('passwords.password')" :invalid-feedback="fErr('password')">
              <b-form-input :type="seePasswords ? 'text' : 'password'"
                :placeholder="$t('passwords.password_placeholder')"
                :class="{ 'is-invalid' : fErr('password') }" v-model="entity.password"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('passwords.password_confirmation')"
              :invalid-feedback="fErr('password_confirmation')">
              <b-form-input :type="seePasswords ? 'text' : 'password'"
                :placeholder="$t('passwords.password_confirmation_placeholder') "
                :class="{ 'is-invalid' : fErr('password_confirmation') }" v-model="entity.password_confirmation"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <div slot="footer" class="pull-right">
          <b-button variant="primary" @click="save()">{{ $t('global.save') }}</b-button>
          <b-button variant="info" class="ml-2" @click="$emit('close')">{{ $t('global.cancel') }}</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Services from '@/services/index';
import Vue from 'vue';

export default {
  mounted() {},
  props: {
    oldPassword: { type: Boolean, default: true },
    userId: { type: [Number, String] },
  },
  data() {
    return {
      spinners: { isSaving: false },
      seePasswords: false,
      entity: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      errorMsg: {}
    };
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    changePassword: Services.users.updatePassword,
    save() {
      if (this.entity.password === this.entity.password_confirmation) {
        this.spinners.isSaving = true;
        this.changePassword(this.userId, this.entity).then((res) => {
          this.spinners.isSaving = false;
          this.alertSuccess();
          this.errorMsg = {};
          this.$emit('close');
        }).catch(({ errors, message }) => {
          this.spinners.isSaving = false;
          this.errorMsg = errors;
          this.alertError({ text: message });
        });
      } else {
        Vue.set(this.errorMsg, 'password_confirmation',
          [this.$t('validation.password_confirmation_does_not_match')]);
      }
    }
  }
};
</script>

<style scoped>
</style>
